import { derived, writable } from 'svelte/store';
import getCreditCardIssuer from '@/getCardIssuer/getCardIssuer';
import getFormattedCardNumber from '@/getFormattedCardNumber/getFormattedCardNumber';
export const name = writable('');
export const number = writable(undefined);
export const cvv = writable(undefined);
export const expireMonth = writable(undefined);
export const expireYear = writable(undefined);
export const isFlipped = writable(undefined);
export const showLogo = writable(true);
export const issuer = derived(number, getCreditCardIssuer);
export const formattedNumber = derived([number, issuer], getFormattedCardNumber);
export const logoSrc = derived([issuer, showLogo], ([$issuer, $showLogo]) => {
    if (!$showLogo || !$issuer) {
        return undefined;
    }
    return `logos/${$issuer}.svg`;
});
